<template>
  <transition name="fade">
  <div class="round-result-container">
    <div class="scoreboard-title">
      {{ isLastRound ? 'Final Scoreboard' : 'Scoreboard' }}
    </div>
    <transition-group name="pop-from-top">
      <div
        class="scoreboard-entry"
        v-for="[index, scoreEntry] in scoreboard.entries()"
        :key="index"
        :style="{ backgroundColor: scoreEntry.primaryColor }"
      >
        <div class="username-item">
          {{ scoreEntry.username }}
        </div>
        <div class="score-item">
          {{ scoreEntry.score }} pts
        </div>
        <transition name="pop-from-top">
          <div
            :class="crowns[index]"
            v-if="index < crowns.length"
          >
            <font-awesome-icon :icon="['fas', 'crown']" />
          </div>
        </transition>
      </div>
    </transition-group>
  </div>
  </transition>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'RoundResultView',
  props: {
    isLastRound: Boolean
  },
  data: () => ({
    scoreboard: []
  }),
  computed: {
    crowns: function () {
      // accounts for ties and will hand out crowns appropriatly. Ties can result in more than 3 players getting a crown.
      let all_crowns = ['first-place-crown', 'second-place-crown', 'third-place-crown'];
      let crowns = ['first-place-crown'];
      let c = 0;

      for (let i = 1; i < this.scoreboard.length; i++) {
        if (this.scoreboard[i - 1].score === this.scoreboard[i].score) {
          crowns.push(all_crowns[c])
        } else if (c < all_crowns.length - 1) {
          c++;
          crowns.push(all_crowns[c]);
        } else {
          break;
        }
      }

      return crowns;
    }
  }
})
</script>

<style lang="scss">
.round-result-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 2em;
  border-radius: 0.2em;
}

.scoreboard-title {
  font-size: 1.6em;
  margin: 1em auto 2em;
}

.scoreboard-entry {
  display: flex;
  position: relative;
  font-size: 1.2em;
  padding: 0.6em 1em;
  margin: 0.5em auto;
  border-radius: 0.4em;
  width: 50%;
  text-shadow: 0 0 8px $natural-white;
}

.username-item {
  flex: 1;
  text-align: left;
  width: max-content;
}

.score-item {
  flex: 1;
  text-align: right;
  width: max-content;
}

.first-place-crown {
  font-size: 2em;
  position: absolute;
  top: -0.8em;
  left: -0.6em;
  color: $metallic-gold;
  transform: rotateZ(-30deg);
}

.second-place-crown {
  font-size: 1.3em;
  position: absolute;
  top: -0.6em;
  left: -0.4em;
  color: $metallic-silver;
  transform: rotateZ(-30deg);
}

.third-place-crown {
  font-size: 1em;
  position: absolute;
  top: -0.6em;
  left: -0.4em;
  color: $metallic-bronze;
  transform: rotateZ(-30deg);
}
</style>
